<template>
  <div class="form-row align-items-end">
    <div v-if="$mods.billing.access_all_families && can(PERMISSIONS.ACCESS_ALL_FAMILIES)" class="col-md-3">
      <form-select :label="Lang.get('messages.branch')" :options="SchoolsForSelect" name="school" :model="localFilters"
        label-field="name" value-field="id" :reduce="(value) => value.id"
        @change="(e) => { loadAllDataToSelects(); updateSelectedNames(); }" :multiple="isSuperadminLoggedSchool"
        :selectAllOption="false" />
    </div>
    <div class="col-md-3" v-if="showAcademicYear">
      <form-select :label="Lang.get('messages.academic_year')" :options="academicYears" name="academicYear"
        :model="localFilters" :errors="formErrors" label-field="name" :reduce="(value) => value.id"
        @change="(e) => { clearInput('academicYear'); setEnrollment(); }" />
    </div>
    <div class="col-md-3">
      <form-select :label="Lang.get('messages.stage')" :options="stagesForSelect" name="stageEnrollment"
        :model="localFilters" :errors="formErrors" label-field="name" @change="getYearLevels()"
        :reduce="(value) => value.id" />
    </div>
    <div class="col-md-3">
      <form-select :label="Lang.get('messages.yearLevel')" :options="yearLevelForSelect" name="yearLevelEnrollment"
        :model="localFilters" :errors="formErrors" label-field="name" :reduce="(value) => value.id"
        @change="(e) => { getClasses(); updateSelectedNames(); }" />
    </div>
    <div class="col-md-3">
      <form-select :label="Lang.get('messages.class')" :options="classes" name="classEnrollment" :model="localFilters"
        :errors="formErrors" label-field="name"
        @change="(e) => { clearInput('class'); updateSelectedNames(); getStudents(); }" :reduce="(value) => value.id" />
    </div>
    <div class="col-md-3">
      <form-select :label="Lang.get('messages.student')" :options="studentsForSelect" name="student"
        :model="localFilters" :errors="formErrors" label-field="name"
        @change="(e) => { clearInput('student'); updateSelectedNames(); }" :reduce="(value) => value.id" />

    </div>
    <slot name="custom" />
  </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import AcademicYear from "@api/academic_year.api"
import YearLevel from "@api/year_level.api";
import School from "@api/school.api";
import Stage from "@api/stage.api";
import Classes from "@api/class.api";
import Student from "@api/student.api";

export default {
  name: "BasicFilter",
  computed: {
    ...mapState("users", ["user"]),
    ...mapGetters(["isSuperadminLoggedSchool"]),

    school() {
      return this.user.school;
    },
  },
  props: {
    filters: {
      type: [Object, Array],
      required: true
    },
    showAcademicYear: {
      type: [Boolean],
      default: true
    },
  },
  watch: {
    localFilters() {
      this.$emit('filtersUpdated', this.localFilters);
    }
  },
  async created() {
    this.localFilters = _.cloneDeep({
      school: '',
      academicYear: '',
      stageEnrollment: '',
      yearLevelEnrollment: '',
      classEnrollment: '',
      student: '',
    });
    await this.getSchools();
    await this.getAcademicYears();
    await this.loadAllDataToSelects();
  },
  data() {
    return {
      academicYears: [],
      yearLevelForSelect: [],
      SchoolsForSelect: [],
      stagesForSelect: [],
      classes: [],
      studentsForSelect: [],
      names: [],
      selectedAcademicYearName: '',
      selectedStudent: '',
      localFilters: {},
    }
  },
  methods: {
    async getSchools() {
      if (this.school && !this.isSuperadminLoggedSchool) {
        this.SchoolsForSelect = [{
          id: this.school.id,
          name: this.school.name
        }];
        _.set(this.localFilters, 'school', this.school.id);
        this.names["selectedSchoolName"] = this.school.name;
        this.$emit('updateNames', this.names);
        return;
      }

      await School.list({ page: 0 }).then(({ data: { data } }) => {
        this.SchoolsForSelect = data;
        _.set(this.filters, 'school', data.map(s => s.id));
      });


    },
    async loadAllDataToSelects() {
      await this.getStages();
    },
    async getStages() {
      this.stagesForSelect = [];
      if (!this.localFilters.school) {
        return
      }
      await Stage.list({
        page: 0, school: this.localFilters.school,
      }).then(res => {
        this.stagesForSelect = res.data.data
      })
    },
    async getYearLevels() {
      this.yearLevelForSelect = [];
      if (!this.localFilters.school || !this.localFilters.stageEnrollment) {
        return
      }
      await YearLevel.list({
        page: 0,
        school: this.localFilters.school,
        stage: this.localFilters.stageEnrollment
      }).then(res => (this.yearLevelForSelect = res.data.data));
    },
    async getClasses() {
      this.classes = [];
      if (!this.localFilters.yearLevelEnrollment || (this.$mods.school_settings.classes.form_inputs.multi_academic_years && !this.localFilters.academicYear)) {
        this.classes = [];
        return false;
      }

      await Classes.list({
        page: 0,
        yearLevel: _.get(this.localFilters, 'yearLevelEnrollment'),
        school: this.localFilters.school,
        academicYears: this.$mods.school_settings.classes.form_inputs.multi_academic_years ? _.get(this.localFilters, 'academicYear') : ''
      }).then((res) => (this.classes = res.data.data));

    },
    async getAcademicYears() {
      await AcademicYear.list({
        page: 0
      }).then(
        ({ data: { data } }) => {
          (this.academicYears = data)
          this.$set(this.localFilters, 'academicYear', data.filter(year => year.active)[0].id || 0);
          this.$set(this.localFilters, 'academicYearEnrollment', data.filter(year => year.active)[0].id || 0);
          if (this.$mods.school.ahlia) {
            this.$set(this.localFilters, 'hasInvoicesTransactionsOrFunded', data.filter(year => year.active)[0].id || 0);
            this.$set(this.localFilters, 'enrollment', 1);
            this.$set(this.localFilters, 'withoutGlobalScope', 'existStudent');
          }
        });
    },
    updateSelectedNames() {
      if (this.localFilters.hasOwnProperty('school')) {
        this.names["selectedSchoolName"] = _.get(this.SchoolsForSelect.find(item => item.id === this.localFilters.school), 'name');
      }
      if (this.localFilters.hasOwnProperty('yearLevelEnrollment')) {
        this.names["selectedYearLevelName"] = _.get(this.yearLevelForSelect.find(item => item.id === this.localFilters.yearLevelEnrollment), 'name');
      }
      if (this.localFilters.hasOwnProperty('classEnrollment')) {
        this.names["selectedClassName"] = _.get(this.classes.find(item => item.id === this.localFilters.classEnrollment), 'name');
      }
      this.$emit('updateNames', this.names);
      if (this.localFilters.academicYear && _.get(this.localFilters, 'student')) {
        this.selectedAcademicYearName = _.get(this.academicYears.find(item => item.id === this.localFilters.academicYear), 'name');
        this.selectedStudent = this.studentsForSelect.find(item => item.id === this.localFilters.student);
        this.$emit("studentSelected", {
          'selectedStudent': this.selectedStudent,
          'selectedAcademicYearName': this.selectedAcademicYearName
        });
      }
    },
    setEnrollment() {
      if (this.localFilters.academicYear) {
        this.$set(this.localFilters, 'academicYearEnrollment', _.get(this.localFilters, 'academicYear'));
        if (this.$mods.school.ahlia) {
          this.$set(this.localFilters, 'hasInvoicesTransactionsOrFunded', _.get(this.localFilters, 'academicYear'));
          this.$set(this.localFilters, 'enrollment', 1);
          this.$set(this.localFilters, 'withoutGlobalScope', 'existStudent');
        }
        this.$set(this.localFilters, "classEnrollment", "");
        this.getClasses();

      }

    },
    async getStudents() {
      await Student.list({
        page: 0,
        school: _.get(this.localFilters, 'school'),
        enrollment: 1,
        yearLevelEnrollment: _.get(this.localFilters, 'yearLevelEnrollment'),
        classEnrollment: _.get(this.localFilters, 'classEnrollment'),
        stageEnrollment: _.get(this.localFilters, 'stageEnrollment'),
        academicYear: _.get(this.localFilters, 'academicYear'),
        academicYearEnrollment: _.get(this.localFilters, 'academicYear'),
        embed: "academicYear"
      }).then(res => {
        this.studentsForSelect = res.data.data;
      });
    },
  }
}
</script>

<style scoped></style>